import { Column, Index, PrimaryGeneratedColumn } from 'typeorm';
import { Entity } from '../../decorators';

/**
 * DomainEntity - Tracks email domains assigned to tenants
 * This is stored in the DVP/shared database to enable lookup
 * of which tenant owns a domain (for email sending verification)
 *
 * Maps to existing table: _domain
 */
@Entity({ name: '_domain' }, { isDvpTable: true })
export class DomainEntity {
	@PrimaryGeneratedColumn({ type: 'int', unsigned: true, name: '_id' })
	id!: number;

	@Column({ type: 'int', unsigned: true, name: '_fk__instance__id' })
	@Index('_domain__fk__instance__id')
	instanceId!: number;

	@Column({ type: 'varchar', length: 65, name: '_domain' })
	domain!: string;

	@Column({ type: 'tinyint', unsigned: true, default: 0, name: '_active' })
	active!: number;

	@Column({ type: 'tinyint', unsigned: true, default: 0, name: '_verified' })
	verified!: number;

	@Column({ type: 'tinyint', default: 0, name: '_public' })
	public!: number;

	@Column({ type: 'tinyint', default: 0, name: '_primary' })
	primary!: number;

	get isActive(): boolean {
		return this.active === 1;
	}

	get isVerified(): boolean {
		return this.verified === 1;
	}
}
